<template>
	<section v-if="cards || header" class="marketing-section bg-color-white">
		<div class="container pb-600-lg">
			<VentureCapitalSectionHeader v-if="header" :header="header" />
			<MarketingSiteCardRow v-if="cards" :cards="cards" theme="light" />
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { LandingPageHeader } from 'types/layout';
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';
import VentureCapitalSectionHeader from '@components/marketing-site/venture-capital/venture-capital-section-header.vue';

interface Props {
	sectionHeader?: LandingPageHeader;
	cards?: Array<MarketingSiteCard>;
}

const props = withDefaults(defineProps<Props>(), {
	sectionHeader: undefined,
	cards: undefined
});

const header = computed(() => props.sectionHeader);
const cards = computed(() => props.cards);
</script>
